import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AssetUIModel, ClientCoreModule } from '@thehubz/client/core';
import { AssetTypeToIconNamePipe } from '../../pipes/asset-type-to-icon-name/asset-type-to-icon-name.pipe';
import { AssetTypeTranslationPipe } from '../../pipes/asset-type-translation/asset-type-translation.pipe';

interface AssetItemBasic {
  previewUrl: string;
  name: string;
  assetType: string;
  imageUrl?: string;
  isProcessing?: boolean;
}

@Component({
  selector: 'thehubz-asset-item-basic',
  templateUrl: './asset-item-basic.component.html',
  styleUrls: ['./asset-item-basic.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, ClientCoreModule, AssetTypeToIconNamePipe, AssetTypeTranslationPipe, MatProgressSpinnerModule],
})
export class AssetItemBasicComponent {
  @Input() item!: AssetItemBasic | AssetUIModel;
  @Input() editFlag?: boolean;
  @Output() remove = new EventEmitter();

  onClickRemove(item: AssetItemBasic) {
    this.remove.emit(item);
  }
}
